import { hour } from "../../data/_data";
import { IconFishingRod } from "../../data/icons";
import { createId } from "../../helper/stringHelper";
import { Tool } from "../../types/types";
import { resourceWood } from "../resources/basic";

// Wooden Hoe
export const toolWoodenFishingRod: Tool = {
  id: createId(),
  name: "Wooden Fishing Rod",
  rarity: "common",
  materialType: "woodenFishingRod",
  icon: IconFishingRod,
  efficiency: 1,
  type: "fishingRod",
  craftingCost: [
    { resource: resourceWood, amount: 2 },
  ],
  tradeValue: 5,
  status: { max: 100, current: 100 },
  time: hour * 4,
};

// Export const for referencing all hoes
export const toolsHoes: Tool[] = [toolWoodenFishingRod];
